import Loadable from 'app/components/Loadable';
import { lazy } from 'react';
import { authRoles } from '../../auth/authRoles';

const SubcontractorList = Loadable(lazy(() => import('./SubcontractorList')));
const AddSubcontractor = Loadable(lazy(() => import('./AddSubcontractor')));

const SubcontractorRoutes = [
  {
    path: '/subcontractor/list',
    element: <SubcontractorList />,
    auth: authRoles.admin,
  },
  {
    path: '/Subcontractor/manage',
    element: <AddSubcontractor />,
    auth: authRoles.admin,
  },
];

export default SubcontractorRoutes;
